import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem } from "@mui/material";
import "./QuoteNavbar.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomButton from "../../Common/CustomButton/CustomButton";

const Navbar = () => {
  const [insuranceMenuAnchorEl, setInsuranceMenuAnchorEl] =
    useState<null | HTMLElement>(null);

  const handleInsuranceMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setInsuranceMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setInsuranceMenuAnchorEl(null);
  };

  return (
    <Box className="navbar px-4 py-3 bg-white fixed w-full top-0">
      <Grid
        container
        padding="0px 4px"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid xs maxWidth="192px">
          <img src="./images/whitelogo.svg" alt="Insurvent" height="52px" />
        </Grid>
        <Grid
          xs
          textAlign="right"
          justifyContent="flex-end"
          alignItems="center"
          className="ctaBtn"
        >
          <CustomButton class_name="whiteMdBtn" text_name="Email Quote" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Navbar;
